import React from 'react';
import './not-found.scss';

function NotFound() {
  return (
    <div className="container not-found">
      <h1 className="not-found__number">404</h1>

      <h2 className="not-found__title">
        You must be lost
      </h2>

      <p className="not-found__text">
        Looks like you’ve followed a broken link or entered a URL that doesn’t exist on this site.
      </p>

      <a href="/" className="not-found__link button button--moving">
        Start from the beginning
      </a>
    </div>
  );
}

export default NotFound;
